const Aparthotels = "Aparthoteles";
const Apartments = "Apartamentos";
const Business = "Negocios";
const Campsites = "Campings";
const Couple = "Pareja";
const Family = "Familia";
const Friend = "Amigos";
const Hostels = "Albergues";
const Hotels = "Hoteles";
const Resorts = "Resorts";
const Restaurants = "Restaurantes";
const es = {
	"{num} reviews": "{num} valoraciones",
	"<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} en {location}",
	"All languages": "Todos los idiomas",
	"All traveler types": "Todo tipo de viajeros",
	Aparthotels: Aparthotels,
	Apartments: Apartments,
	"Arrow icon": "Icono de flecha",
	"B&Bs": "B&Bs",
	"based on {number} reviews": "basado en {number} valoraciones",
	Business: Business,
	Campsites: Campsites,
	Couple: Couple,
	Family: Family,
	Friend: Friend,
	"Highlighted reviews": "Valoraciones destacadas",
	Hostels: Hostels,
	Hotels: Hotels,
	"Information icon": "Icono de información",
	"No reviews found": "No se han encontrado reseñas",
	"Pet-friendly": "Admite mascotas",
	"Posted on {reviewer}": "Publicado en {reviewer}",
	"Read Reviews": "Ver reseñas",
	Resorts: Resorts,
	Restaurants: Restaurants,
	"Review Summary": "Valoraciones",
	"Reviews by Source": "Valoraciones por fuente"
};

export { Aparthotels, Apartments, Business, Campsites, Couple, Family, Friend, Hostels, Hotels, Resorts, Restaurants, es as default };
//# sourceMappingURL=es.CgXzWNMZ.js.map
